import React, { useEffect, useState, useRef, useContext } from "react";
import ComparisonItem from "./comparison-item";
import { AppSettings } from "../../config/app-settings";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import { Card, CardBody, CardHeader  } from "../../components/card/card";
import { CardExpandToggler } from "../sensor/utils";
function MachineList() {
  const context = useContext(AppSettings);
  useEffect(() => {
    // context.setAppContentFullHeight(true);
    // context.setAppContentClass("p-0");
    // context.setAppSidebarCollapsed(true);

    // var lightbox;

    // if (!lightbox) {
    //   lightbox = new PhotoSwipeLightbox({
    //     gallery: ".gallery-image-list",
    //     children: "a",
    //     pswpModule: () => import("photoswipe"),
    //   });
    //   lightbox.init();
    // }

    // return function cleanUp() {
    //   context.setAppContentFullHeight(false);
    //   context.setAppContentClass("");
    //   context.setAppSidebarCollapsed(false);

    //   if (lightbox) {
    //     lightbox.destroy();
    //     lightbox = null;
    //   }
    // };

    // eslint-disable-next-line
  }, []);
  return (
    <div >
      <Card>
        <CardHeader>
          <CardExpandToggler/>
          </CardHeader>
      <CardBody>
      <div className="row justify-content-center">
        <div className="col-12 col-md-6">
          <ComparisonItem></ComparisonItem>
        </div>
        <div className="col-12 col-md-6">
          <ComparisonItem></ComparisonItem>
        </div>
      </div>
      </CardBody>
      </Card>
    </div>
  );
}

export default MachineList;
